import React     from 'react';
import useStyles from './resetPasswordPageStyles';
import usePOST   from 'rest/usePOST';
import useURL    from 'utils/useURL';

import Alert             from 'components/Alert';
import Button            from '@mui/material/Button';
import Container         from '@mui/material/Container';
import Paper             from '@mui/material/Paper';
import ResetPasswordForm from 'pages/ResetPasswordPage/ResetPasswordForm';
import Typography        from '@mui/material/Typography';

import areNewPasswordsValid    from './areNewPasswordsValid';
import createRestRequestConfig from 'rest/createRestRequestConfig';

import { REASONS }                    from './areNewPasswordsValid';
import INTERNAL_PATHS                 from 'routing/internalPaths';
import { FINTECH_PATHS }              from 'rest/const';
import { NEW_PASSWORD_FIELD_NAME }    from './ResetPasswordForm/ResetPasswordForm';
import { PASSWORD_REPEAT_FIELD_NAME } from './ResetPasswordForm/ResetPasswordForm';
import { useNavigate }                from 'react-router-dom';
import { useTranslation }             from 'react-i18next';
import Grid                           from '@mui/material/Grid';


function ResetPasswordPage() {

  //TODO this page has too much in common with LoginPage - refeactoring is needed

  const navigate    = useNavigate();
  const { t }       = useTranslation();
  const { classes } = useStyles();

  const [alert, setAlert]                     = React.useState(undefined);
  const [tokenInvalid, setTokenInvalid]       = React.useState(false);
  const [submitData, setSubmitData]           = React.useState(undefined);
  const [resetSuccessful, setResetSuccessful] = React.useState(false);

  const { token, email, hasTokenExpired } = useURL(() => setTokenInvalid(true));


  React.useEffect(() => {
    if (tokenInvalid) {
      setAlert({
        msgTranslKey: 'tokenInURLInvalid',
        type:         'error',
      });
    } else if (hasTokenExpired) {
      setAlert({
        msgTranslKey: 'tokenExpired',
        type:         'error',
      });
    }
  }, [tokenInvalid, hasTokenExpired]);

  function redirectToLoginPage() {
    const navigateTo = INTERNAL_PATHS.login;
    navigate(navigateTo);
  }

  function handleResetPassword() {
    setResetSuccessful(true);
    setAlert({
      msgTranslKey: 'passwordSetSuccessfully',
      type:         'success'
    });
  }

  function onRestError(err) {
    //TODO add more specific handling when API is developed
    console.error("ResetPasswordPage, onRestError: ", err);
    setAlert({
      msgTranslKey: 'serverError',
      type:         'warning'
    });
  }

  const swrOptions               = {
    shouldRetryOnError:    false,
    revalidateOnFocus:     false,
    revalidateOnReconnect: false,
    revalidateIfStale:     false,
    onSuccess:             handleResetPassword,
    onError:               onRestError,
  }
  const axiosCfg                 = createRestRequestConfig(token, true);
  const path                     = submitData ? FINTECH_PATHS.resetPassword : null;
  const { isValidating, mutate } = usePOST(path, submitData, axiosCfg, swrOptions);

  function createAlert(reason) {
    if (reason === REASONS.doNotMatch)
      return { msgTranslKey: 'passwordsDoNotMatch', type: 'warning' }
    return null;
  }

  function handleSubmit(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.target);
    const parsed   = {}

    for (const [key, value] of formData.entries()) {
      parsed[key] = value
    }

    let { valid, reason } = areNewPasswordsValid(
      parsed[NEW_PASSWORD_FIELD_NAME], parsed[PASSWORD_REPEAT_FIELD_NAME]
    );

    if (valid) {
      const toBeSubmitted = {
        credentials: {
          type:     'EMAIL',
          username: email,
          password: parsed[NEW_PASSWORD_FIELD_NAME]
        }
      }
      setSubmitData(toBeSubmitted);
      mutate();
    } else
      setAlert(createAlert(reason));
  }

  if (resetSuccessful) {
    return (
      <Container maxWidth='xs'>
        <Alert alert={alert} setAlert={setAlert}/>
        <Grid container justifyContent='center'>
          <Grid item>
            <Button onClick={redirectToLoginPage}>
              {t('redirectToLoginPage')}
            </Button>
          </Grid>
        </Grid>
      </Container>
    )
  }

  return (
    <Container maxWidth='xs'>
      <Alert alert={alert} setAlert={setAlert}/>
      <Paper elevation={6} className={classes.mainPaper}>
        <Paper elevation={0} className={classes.titlePaper}>
          <Typography
            align='center'
            variant='subtitle1'
            className={classes.title}
          >
            {t('resetPasswordTitle')}
          </Typography>
        </Paper>
        <ResetPasswordForm
          onSubmit={handleSubmit}
          isInProgress={isValidating}
          disabled={tokenInvalid || hasTokenExpired}
          email={email}
        />
      </Paper>
    </Container>
  );
}

export default ResetPasswordPage;